module.exports = __webpack_public_path__ + "img/20201006_120113.e543b0ad.jpg";